/**
 * Controller for `tmrToast` preset.
 * Ported from Angular Material simple toast controller.
 *
 * @type {ngController}
 */
export class tmrToastController {
  static ngType = 'controller'

  constructor($mdToast) {
    'ngInject'
    Object.assign(this, { $mdToast, ACTION_RESOLVE: 'ok' })
  }

  resolve() {
    this.$mdToast.hide(this.ACTION_RESOLVE)
  }
}
